module.exports = __webpack_public_path__ + "img/8.cb40a008.jpg";